export const BASE_URL = "https://api.thediamondcounter.com";
export const apiUrl = {
  LOGIN: `${BASE_URL}/user/login`,
  SIGNUP: `${BASE_URL}/user/user`,
  GET_PROFILE: `${BASE_URL}/user/profile/get`,
  GET_MOB_FEATURE_CATEGORY: `${BASE_URL}/category/featurelist/get`,
  UPDATE_PROFILE: `${BASE_URL}/user/profile/update`,
  GET_MOB_CATEGORY: `${BASE_URL}/category/get`,
  GET_SPECIFICATION: `${BASE_URL}/data/get`,
  GET_BANNER: `${BASE_URL}/banner/get`,
  GET_BANNER_PRODUCT: `${BASE_URL}/product/banner/get`,
  GET_SEARCH_PRODUCT: `${BASE_URL}/search/get`,
  // Slug -> product id. The product page needs an exact answer on a direct visit,
  // a refresh or a shared link; searching for the de-slugified words cannot give
  // one. See backend/utils/productSlugIndex.js.
  RESOLVE_PRODUCT_SLUG: `${BASE_URL}/product/by-slug`,
  ADD_PRODUCT_NOTIFY: `${BASE_URL}/product/notify/add`,

  GET_ALL_PRODUCT: `${BASE_URL}/product/get`,
  GET_SINGLE_PRODUCT_ID: `${BASE_URL}/product/get/single`,
  
  GET_FILTERLIST_PRODUCT: `${BASE_URL}/search/get/filterList`,
  
  GET_FEATURE_LIST: `${BASE_URL}/product/get/features/productlist`,

  ADD_TO_CART: `${BASE_URL}/cart/add`,
  GET_CART_LIST: `${BASE_URL}/cart/cartItems/get`,
  PUT_CART_LIST: `${BASE_URL}/cart/cartItems/update`,
  DELETE_CART_LIST: `${BASE_URL}/cart/cartItems/delete`,
  DELETE_ALL_CART_LIST: `${BASE_URL}/cart/all/cartItems/delete`,
  GET_WISH_LIST: `${BASE_URL}/wishlist/get`,
  ADD_WISH_LIST: `${BASE_URL}/wishlist/addremove`,
  ADD_ADDRESS: `${BASE_URL}/address/add`,
  GET_ALL_ADDRESS: `${BASE_URL}/address/get`,
  UPDATE_ADDRESS: `${BASE_URL}/address/update`,
  DELETE_ADDRESS: `${BASE_URL}/address/delete`,
  ADD_ORDER: `${BASE_URL}/order/add`,
  GET_ALL_ORDER: `${BASE_URL}/order/getAll`,
  UPDATE_ORDER: `${BASE_URL}/order/update/singleOrder/type`,
  SINGLE_ORDER_ID: `${BASE_URL}/order/get/singleOrder`,
  SINGLE_ORDER_DETAILS: `${BASE_URL}/order/get/singleDetail`,
  GET_ALL_SETTING: `${BASE_URL}/app/settings/get`,
  ADD_COUPON_CODE: `${BASE_URL}/coupon/check/couponcode/forordertime`,
  GET_COUPON_CODE: `${BASE_URL}/coupon/get/all/forordertime`,
  GET_ALL_REVIEW: `${BASE_URL}/review/get/all`,
  GET_PRODUCT_REVIEW: `${BASE_URL}/review/get/product`,
  ADD_REVIEW: `${BASE_URL}/review/add`,
  GET_SINGLE_REVIEW: `${BASE_URL}/review/get/single`,
  GET_PAYMENT_GETWAY: `${BASE_URL}/processPayment`,
  ADD_WALLET: `${BASE_URL}/wallet/history/add`,
  GET_POPUP_BANNER:`${BASE_URL}/popup/banner/get`,
  GET_MARQUEE:`${BASE_URL}/getMarquee`,
  ADD_NEWSLETTER:`${BASE_URL}/newsletter/post/subscribe`,
  ADD_CONTACT_US: `${BASE_URL}/contact/add`,
  ADD_RETAILER_QUERY: `${BASE_URL}/retailer-query/add`,
  GET_METAL_PRICES: `${BASE_URL}/metal/public/prices`,
  FORGOT_PASSWORD: `${BASE_URL}/user/forgot-password`,
  RESET_PASSWORD: `${BASE_URL}/user/reset-password`,
};
